export default __webpack_public_path__ + "static/media/section3_4.54cf959a.png";